import React from "react";
import Preloader from "../helper/Preloader";
import Breadcrumb from "../components/Breadcrumb";
import Shipping from "../components/Shipping";
import User from "../components/User";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";

const UserPage = () => {
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* Breadcrumb */}
      <Breadcrumb title={"User Dashboard"} />

      {/* User Dashboard */}
      <User />

      {/* Shipping */}
      <Shipping />

      
    </>
  );
};

export default UserPage;

